import { render, staticRenderFns } from "./OferteProductie.vue?vue&type=template&id=8a05cc3e&scoped=true"
import script from "./OferteProductie.vue?vue&type=script&lang=js"
export * from "./OferteProductie.vue?vue&type=script&lang=js"
import style0 from "./OferteProductie.vue?vue&type=style&index=0&id=8a05cc3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a05cc3e",
  null
  
)

export default component.exports